import { Button, Snackbar } from '@mui/material'
import { useState } from 'react'
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import '../../App.css'
const CopyToClipboardButton = ({keyString}) => {
    const [open, setOpen] = useState(false)
    const handleClick = () => {
      setOpen(true)
      navigator.clipboard.writeText(keyString)
    }

    
    return (
        <div style={{display: 'block', left: '10px', position: 'relative',}}>
          <Button onClick={handleClick} style={{ color: '#fff', border: 'transparent', padding: '0', width: '10px'}}>
          <ContentCopyIcon titleAccess='Copy License Key'/></Button>
          <Snackbar 
            open={open}
            onClose={() => setOpen(false)}
            autoHideDuration={2000}
            message="Copied to clipboard"
          />
        </div>
    )
}

export default CopyToClipboardButton;
